export default "__VITE_ASSET__DsdI3pqu__"